var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticClass:"px-12 mx-12 py-9"},[_c('p',[_vm._v("access_token: "+_vm._s(_vm.access_token))]),_c('p',[_vm._v("refresh_token: "+_vm._s(_vm.refresh_token))]),_c('p',[_vm._v(_vm._s(_vm.response))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }